import Utils from '@/pages/Program/util2.js';

export default {
    name: "mlesson",
    data() {
        return {
            mathStartLesson: null,
            progress: 0,
            isPlay: false,
            currentTime: 0,
            mTimer: null
        }
    },
    methods: {
        goToBack() {
            window.MLessonScrollTop = 0;
            this.goBack(this.$router);
        },
        getStateHeight: function () {
            return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
        },
        showStatus: function (status) {
            let that = this;
            let vPlatform = that.judgePlatform();

            if (vPlatform === 3) {
                document.location = "readingclubapp:showStatusView:" + status;
            }

            if (vPlatform === 4) {
                window.note.showStatusView(status);
            }
        },
        judgePlatform: function () {
            let that = this;
            // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
            let Platform = 0;
            let token = that.$store.state.token;
            let userid = that.$store.state.userid.toString();

            if (that.isWeixinBrowser()) {
                // 微信平台
                if (that.isAppIos()) {
                    Platform = 1;
                } else {
                    Platform = 2;
                }
            } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                // app平台
                if (that.isAppIos()) {
                    Platform = 3;
                } else {
                    Platform = 4;
                }
            } else {
                Platform = 0;
            }

            return Platform;
        },
        hideStatusAndStopAudio: function () {
            let that = this;
            let vPlatform = that.judgePlatform();

            if (vPlatform === 3) {
                document.location = "readingclubapp:hideStatusAndStopAudio";
            }

            if (vPlatform === 4) {
                window.note.hideStatusAndStopAudio();
            }
        },
        changeStart: function () {
            let that = this;
            that.isPlay = !that.isPlay
            const musicMp3 = document.getElementById('musicMp3');
            if (that.isPlay) {
                if (that.mTimer == null) {
                    that.changeProgress();
                }
                musicMp3.play()
            } else {
                musicMp3.pause()
            }
        },
        changeProgress: function () {
            let that = this;
            const musicMp3 = document.getElementById('musicMp3');

            that.mTimer = setInterval(() => {
                const numbers = musicMp3.currentTime / musicMp3.duration;
                let perNumber = (numbers * 100).toFixed(2);
                if (perNumber >= 100) {
                    that.isPlay = false;
                    that.progress = 0;
                    that.currentTime = 0;
                    clearInterval(that.mTimer);
                    that.mTimer = null;
                } else {
                    that.progress = perNumber;
                    that.currentTime = musicMp3.currentTime;
                }
            }, 50)
        },
        callChangeProgress: function () {
            let that = this;
            document.getElementById('musicMp3').pause()
            that.changeProgress()
        },
        followWordsClick: function () {
            this.$router.push({
                name: 'MCoreWord', query: {lessonId: this.lessonId, courseId:this.mathStartLesson.courseId}
            });
        },
        mindMapClick: function () {
            this.$router.push({
                name: 'MPractice', query: {lessonId: this.lessonId, modeType:0}
            });
        },
        mathExercisesClick: function () {
            let hasLine = this.getCount(this.mathStartLesson.hasConnectLineQuestion) === 1;

            this.$router.push({
                name: hasLine ? 'MConnectlinequestion' : 'MPractice', query: {lessonId: this.lessonId, modeType:1}
            });
        },
        expandClick: function () {
            let that = this;
            Utils.$emit('setFinishPart', that.lessonId, 4);

            this.$router.push({
                name: 'MExpansion', query: {lessonId: this.lessonId}
            });
        },
        punchTask: function () {
            if (this.isAppIos()) {
                document.location = "readingclubapp:punchDynamicsClick:1:" + this.courseId + ":" + this.lessonId;
            }

            if (this.isAppAndroid()) {
                // 打卡动态
                window.note.punchDynamicsClick(1, this.courseId, this.lessonId);
            }
        }
    },
    beforeRouteEnter(to, form, next) {
        next(vm=>{
            vm.showStatus(0);
        });
    },
    beforeRouteLeave(to, from, next) {
        if (to.name !== "MAfter") {
            window.MLessonScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        }

        this.showStatus(1);
        next();
    },
    mounted: function () {
        window.MLessonScrollTop = 0;
    },
    activated() {
        window.scrollTo(0, window.MLessonScrollTop);
    },
    beforeCreate() {
        let that = this;
        let vLessonId = that.getCount(this.$route.query.lessonId);
        let vCourseId = that.getCount(that.$route.query.courseId);
        let url = "mathStart/getLessonHomeInfo/" + vLessonId;

        this.$axios.get(url).then((response) => {
            that.mathStartLesson = response.data;
            that.lessonId = vLessonId;
            that.courseId = vCourseId;
            that.userId = parseInt(that.$store.state.userid.toString());

            setTimeout(function () {
                that.hideStatusAndStopAudio();
            }, 200);

            if (!that.isWeixinBrowser()) {
                that.$nextTick(() => {
                    $(window).scroll(function () {
                        var scrollTop = parseFloat(parseFloat($(window).scrollTop()));

                        if (scrollTop > 44) {
                            $("#navigation_title").removeClass("navigation");
                            $("#navigation_title").addClass("navigation_white");
                        } else {
                            $("#navigation_title").removeClass("navigation_white");
                            $("#navigation_title").addClass("navigation");
                        }
                    });
                });
            }
        }).catch(function (error) {
            window.console.log(error)
        });
    }
}
